import React, { useContext } from 'react';
import { JobPostModalContext } from '@components/common/jobPostModal/JobPostModalWrap';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';

import classnames from 'classnames/bind';
import styles from './jobPostingButton.module.scss';

const cx = classnames.bind(styles);

interface JobPostingButtonProps {
  positionDetail: PositionDetailVO;
}

const JobPostingButton = ({ positionDetail }: JobPostingButtonProps) => {
  const { jobPosting } = positionDetail;
  const { onOpenJobPostModal } = useContext(JobPostModalContext);

  if (!jobPosting) return null;

  const handleClick = () => {
    onOpenJobPostModal(`${jobPosting.jobPostingSn}`, jobPosting.jobPostingSn);
  };

  return (
    <a role="button" className={cx('jobPostingButton')} onClick={handleClick}>
      {jobPosting.jobPostingName}
    </a>
  );
};

export default JobPostingButton;
